import React from "react";
import moment from "moment";
import { BorderedButton } from "../../components/Button";
import { DatePicker } from "../../components/DatePicker";
import { Flex } from "../../components/Flex";
import { RadioButtonGroup } from "../../components/Radio";
import { ArrowFilledIcon } from "../../icons/ArrowFilledIcon";
import { dateFormat, INTERVALS } from "../../settings";

const ShcDatesPanel = ({ interval, dates, onChange }) => {

    const onIntervalChange = (value) => {
        let newdates = dates.map(d => moment(d));
        newdates[0] = newdates[1].clone().subtract(1, value).add(1, "day");
        onChange({ interval: value, dates: newdates.map(d => d.format(dateFormat)) });
    };

    const onDatesChange = (value) => {
        let newinterval = interval, newdates = dates;
        if (Array.isArray(value)) {
            newdates = value;
            newinterval = moment(value[1]).add(1, "day").startOf("day").diff(moment(value[0]), "day", true);
            INTERVALS.map(i => {
                if (moment(value[1]).add(1, "day").startOf("day").diff(moment(value[0]), i.key, true) === 1) {
                    newinterval = i.key;
                };
            });
        } else {
            newdates = [value, value];
        };
        onChange({ interval: newinterval, dates: newdates.map(d => d.format(dateFormat)) });
    };

    const onDatesRangeChange = (value) => {
        let sampleinterval = Number.isInteger(interval) ? 'day' : interval;
        let cnt = Number.isInteger(interval) ? interval : 1;
        let newdates = dates.map(d => moment(d).clone().add(cnt*value, sampleinterval));

        onChange({ interval: interval, dates: newdates.map(d => d.format(dateFormat)) });
    }

    return(
        <Flex gap={{ right: 16 }}>
            <RadioButtonGroup buttons={INTERVALS} value={interval} onChange={value => onIntervalChange(value)} />
            <Flex gap={{ right: 8 }}>
                <BorderedButton onClick={() => onDatesRangeChange(-1)}><ArrowFilledIcon /></BorderedButton>
                {interval === "day"
                    ? <DatePicker value={moment(dates[0])} onChange={(date, dateString) => onDatesChange(date)} />
                    : <DatePicker.RangePicker value={dates.map(d => moment(d))} onChange={(dates, dateString) => onDatesChange(dates)}/>
                }
                <BorderedButton onClick={() => onDatesRangeChange(1)}><ArrowFilledIcon rotate={180} /></BorderedButton>
            </Flex>
        </Flex>
    )
};

export { ShcDatesPanel };